import { render, staticRenderFns } from "./UserTargetForm.vue?vue&type=template&id=2c2dd93e"
import script from "./UserTargetForm.vue?vue&type=script&lang=js"
export * from "./UserTargetForm.vue?vue&type=script&lang=js"
import style0 from "./UserTargetForm.vue?vue&type=style&index=0&id=2c2dd93e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports